import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import updateConversionRate from "../../utils/updateConversionRate";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const ProductValueReport = (props) => {
  const element = props.element;
  const sanitizedValue = props.value.replace(/[^a-zA-Z0-9]/g, "");
  const idPrefix = props.reportIdPrefix || "";

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report"
        data-element-id={element.id}
        data-product-value={props.value}
        data-report-id-prefix={idPrefix}
        style={{ width: "100%" }}
      >
        <div
          className="element-selection-report-bar"
          style={{
            width: "100%",
          }}
        ></div>
        <div className="row hard-center funnel-breakdown-item-row">
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl ellipsis funnel-breakdown-question-text"
              style={{ marginBottom: "5px" }}
            >
              {props.label}
            </div>
          </div>
          <div className="col-xs-8 right">
            <p className="light" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  id={`${idPrefix}product-value-${sanitizedValue}`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type: ["Complete", "Add To Cart"],
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      product_id: null,
                      range_start: props.range_start,
                      range_end: props.range_end,
                      field: null,
                      value: props.value,
                    },
                  }}
                  callback={() => {
                    props.calculationConversionRates();

                    updateConversionRate(
                      `[id="${idPrefix}product-value-${sanitizedValue}"]`,
                      `[id="${idPrefix}product-value-${sanitizedValue}-orders"]`,
                      `[id="${idPrefix}product-value-${sanitizedValue}-order-rate"]`
                    );
                  }}
                />
              </strong>{" "}
              selected (<span className="conversion-rate">0.00</span>
              %)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}product-value-${sanitizedValue}`}
                selectionsId={`${idPrefix}product-value-${sanitizedValue}`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  field: null,
                  value: props.value,
                  product_id: null,
                  product_variant_id: null,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductValueReport;
